import { render, staticRenderFns } from "./TreatmentTable.vue?vue&type=template&id=158c863c&"
import script from "./TreatmentTable.vue?vue&type=script&lang=js&"
export * from "./TreatmentTable.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports